import './css';

import './web';



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/index.js